import React from 'react';
import { motion } from 'framer-motion';
import { useDrag, useDrop } from 'react-dnd';

export const DraggableItem: React.FC<{
  children: React.ReactElement;
  index: number;
  moveItem: (dragIndex: number, hoverIndex: number) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
}> = ({ children, index, moveItem, disabled = false, style }) => {
  const ref = React.useRef<HTMLDivElement>(null);

  const [{ isDragging }, drag] = useDrag({
    type: 'ITEM',
    item: { index },
    canDrag: !disabled,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: 'ITEM',
    drop: (draggedItem: { index: number }) => {
      if (disabled) return;

      // 检查是否移动到不同位置
      if (draggedItem.index !== index) {
        moveItem(draggedItem.index, index);
      }
    },
  });

  if (!disabled) {
    drag(drop(ref));
  } else {
    drop(ref);
  }

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={{
        opacity: isDragging ? 0.7 : 1,
        y: 0,
      }}
      transition={{ duration: 0.2 }}
      whileHover={{ border: disabled ? 'none' : '1px solid rgba(16, 95, 200, .6)' }}
      className="grid-item"
      style={{
        cursor: disabled ? 'default' : 'move',
        opacity: isDragging ? 0.7 : disabled ? 0.5 : 1,
        height: '100%',
        border: '1px solid transparent',
        borderRadius: '4px',
        ...style,
      }}
    >
      {children}
    </motion.div>
  );
};
